export { default } from "./useLazyContentPromotionFormPost";
